import {find, findIn, findAll} from '@elements/dom-utils';
import {onFind, findAllIn} from "@elements/init-modules-in-scope";
import {activateScrollLock, deactivateScrollLock} from "@elements/scroll-lock";

const defaultSelectors = {
    base: '.js-filter-mobile__toggle',
    overlay: 'filter-mobile__overlay',
    close: '.js-filter-mobile__close',
    filter: '.js-filter-category',
    reset: '.js-filter-category-reset',
};

export function init(selectors = defaultSelectors) {

    onFind(selectors.base, function (baseElement) {
        let overlay = document.getElementById(selectors.overlay);
        baseElement.addEventListener("click", function (event) {
        overlay.classList.add('is-open');
            activateScrollLock();
            baseElement.classList.add('d-none');
        })

        onFind(selectors.close, function (closeElement) {
            closeElement.addEventListener('click', () => {
                overlay.classList.remove('is-open');
                deactivateScrollLock();
                baseElement.classList.remove('d-none');
            })
        });

        onFind(selectors.filter, function (filterElement) {
            filterElement.addEventListener('click', () => {
                overlay.classList.remove('is-open');
                deactivateScrollLock();
                baseElement.classList.remove('d-none');
            })
        });

        onFind(selectors.reset, function (filterElement) {
            filterElement.addEventListener('click', () => {
                overlay.classList.remove('is-open');
                deactivateScrollLock();
                baseElement.classList.remove('d-none');
            })
        });
    })



}